import type { BuyerOptionsMap } from '@openx/utils/apiHooks/useBuyersFetch.ts';

export const getMainBuyerOptions = (buyerIds: string[], byersOptions: string[]) =>
  buyerIds.length ? byersOptions.filter(option => !buyerIds.includes(option)) : byersOptions;

export const getByersWithoutMainBuyer = (mainBuyer: string | null, byersOptions: string[]) =>
  mainBuyer ? byersOptions.filter(option => option !== mainBuyer) : byersOptions;

export const getDeletedSeats = (selectedSeatIds: string[], buyers?: BuyerOptionsMap, isBuyersLoading?: boolean) => {
  if (selectedSeatIds.length && buyers && !isBuyersLoading) {
    return selectedSeatIds.map(buyer => (buyers[buyer] ? buyer : null));
  } else {
    return selectedSeatIds;
  }
};

export const prepareBuyerIdsForBuyerChange = (
  mainBuyer: string | null,
  buyersOptionsMap: BuyerOptionsMap,
  value: string[]
) => {
  const buyerIds: Set<string> = new Set();
  if (mainBuyer) {
    buyerIds.add(buyersOptionsMap[mainBuyer].buyer_id.toString());
  }
  value.forEach(buyerId => {
    buyerIds.add(buyersOptionsMap[buyerId].buyer_id.toString());
  });

  return [...buyerIds];
};
